import React from 'react';

/**
 * Simple cookie consent banner for analytics.
 * Props:
 * - onAccept: () => void
 * - onDecline: () => void
 */
export default function CookieConsent({ onAccept, onDecline }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-5xl p-4">
        <div className="rounded-2xl border border-slate-200 bg-white/95 shadow-2xl backdrop-blur-md dark:border-white/10 dark:bg-slate-900/95">
          <div className="p-4 sm:p-5">
            <p className="text-sm text-slate-600 dark:text-slate-300">
              Vi använder endast analys-cookies med ditt samtycke för att förbättra upplevelsen. Du kan acceptera eller avvisa analys-cookies.
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={onDecline}
                className="btn border border-slate-300 !py-2 text-slate-700 hover:bg-slate-100 dark:border-white/15 dark:text-slate-200 dark:hover:bg-white/5"
              >
                Avvisa
              </button>
              <button
                type="button"
                onClick={onAccept}
                className="btn-primary !py-2"
              >
                Acceptera
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
